
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/openings/[slug]",
      function () {
        return require("private-next-pages/openings/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/openings/[slug]"])
      });
    }
  